import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PreferredPartnerService } from '../../preferred-partner.service';
import { SummaryRegion, SummaryResponse } from '../../types';

/**
 * Compact widget for the owner-dashboard. Pulls the cached summary feed
 * (60s throttle inside the service) and surfaces:
 *   - per-region status (chip),
 *   - drivers eligible / shifts evaluated,
 *   - bonus this week.
 *
 * Click anywhere -> navigate to /preferred-partner.
 */
@Component({
  selector: 'lohi-ppp-summary-card',
  templateUrl: './ppp-summary-card.component.html',
  styleUrls: ['./ppp-summary-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PppSummaryCardComponent implements OnInit, OnDestroy {
  public readonly summary$: Observable<SummaryResponse | null>;

  private destroy$$ = new Subject<void>();

  constructor(private pppService: PreferredPartnerService) {
    this.summary$ = this.pppService.summary$;
  }

  public ngOnInit(): void {
    // Touching the getter publishes a refresh tick into the throttled stream.
    this.pppService.summary$.pipe(takeUntil(this.destroy$$)).subscribe();
  }

  public ngOnDestroy(): void {
    this.destroy$$.next();
    this.destroy$$.complete();
  }

  public trackByRegion(index: number, region: SummaryRegion): number {
    return region.regionId;
  }
}
